import { Injectable } from '@angular/core';
import { ProfileService } from 'app/core/components/profile/profile.service';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

const CACHE_SIZE = 1;

@Injectable()
export class CacheService {
  clearCache$ = new Subject<void>();

  private profile$: Observable<any>;
  constructor(private profileService: ProfileService) { }

  getCachedProfile(): Observable<any> {
    if (!this.profile$)
      this.profile$ = this.profileService.getProfile().takeUntil(this.clearCache$).shareReplay(CACHE_SIZE);
    return this.profile$;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/cache.service.ts